module.exports = __webpack_public_path__ + "img/744.a3f277ae.jpg";